(function(factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['./ApiClient', './model/Account', './model/Accounts', './model/Acquisition', './model/Activationchallenge', './model/AddMember', './model/AddPending', './model/AddRating', './model/BlendedPackage', './model/Body', './model/ChangeCurrentAccount', './model/ClonePackage', './model/ConflictFile', './model/CreateAccount', './model/CreateCanonical', './model/CreateCanonicalVersion', './model/CreatePackage', './model/CreateVersion', './model/Dependencies', './model/DependenciesList', './model/Documents', './model/Error', './model/ErrorResponse400', './model/ErrorResponse500', './model/Files', './model/GetUpdates', './model/HyperLinkAccount', './model/HyperLinkCanonicalVersion', './model/HyperLinkDependencyPackages', './model/HyperLinkDraft', './model/HyperLinkLicenses', './model/HyperLinkRatings', './model/HyperLinkValidators', './model/InlineResponse200', './model/License', './model/Login', './model/Logout', './model/MakeActive', './model/MemberAccount', './model/MemberAccounts', './model/Menu', './model/MergePackage', './model/NavigationItems', './model/NavigationItemsItems', './model/NavigationMeta', './model/NavigationSetting', './model/Navigations', './model/NavigationsMeta', './model/NewDraft', './model/Operands', './model/PackageImages', './model/Packages', './model/PendingAccount', './model/PendingAccounts', './model/PullPackage', './model/PushPackage', './model/Rating', './model/RejectAcquisitionPackage', './model/ResendAccountVerificationLink', './model/ResendInvite', './model/ResetPassword', './model/SaveFile', './model/SessionData', './model/SetUpdates', './model/SharedPackageAccount', './model/SharedPackageAccountsList', './model/ThemeSettings', './model/UpdateAccount', './model/UpdateDraft', './model/UpdateLocal', './model/UpdatePackage', './model/UpdateVersion', './model/UploadMedia', './model/User', './model/UserData', './model/Users', './model/Validator', './model/ValidatorPlan', './model/Version', './model/Versions', './model/WordPressSettings', './api/AccountsApi', './api/LibraryApi', './api/LocalApi', './api/PackagesApi', './api/SettingsApi'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('./ApiClient'), require('./model/Account'), require('./model/Accounts'), require('./model/Acquisition'), require('./model/Activationchallenge'), require('./model/AddMember'), require('./model/AddPending'), require('./model/AddRating'), require('./model/BlendedPackage'), require('./model/Body'), require('./model/ChangeCurrentAccount'), require('./model/ClonePackage'), require('./model/ConflictFile'), require('./model/CreateAccount'), require('./model/CreateCanonical'), require('./model/CreateCanonicalVersion'), require('./model/CreatePackage'), require('./model/CreateVersion'), require('./model/Dependencies'), require('./model/DependenciesList'), require('./model/Documents'), require('./model/Error'), require('./model/ErrorResponse400'), require('./model/ErrorResponse500'), require('./model/Files'), require('./model/GetUpdates'), require('./model/HyperLinkAccount'), require('./model/HyperLinkCanonicalVersion'), require('./model/HyperLinkDependencyPackages'), require('./model/HyperLinkDraft'), require('./model/HyperLinkLicenses'), require('./model/HyperLinkRatings'), require('./model/HyperLinkValidators'), require('./model/InlineResponse200'), require('./model/License'), require('./model/Login'), require('./model/Logout'), require('./model/MakeActive'), require('./model/MemberAccount'), require('./model/MemberAccounts'), require('./model/Menu'), require('./model/MergePackage'), require('./model/NavigationItems'), require('./model/NavigationItemsItems'), require('./model/NavigationMeta'), require('./model/NavigationSetting'), require('./model/Navigations'), require('./model/NavigationsMeta'), require('./model/NewDraft'), require('./model/Operands'), require('./model/PackageImages'), require('./model/Packages'), require('./model/PendingAccount'), require('./model/PendingAccounts'), require('./model/PullPackage'), require('./model/PushPackage'), require('./model/Rating'), require('./model/RejectAcquisitionPackage'), require('./model/ResendAccountVerificationLink'), require('./model/ResendInvite'), require('./model/ResetPassword'), require('./model/SaveFile'), require('./model/SessionData'), require('./model/SetUpdates'), require('./model/SharedPackageAccount'), require('./model/SharedPackageAccountsList'), require('./model/ThemeSettings'), require('./model/UpdateAccount'), require('./model/UpdateDraft'), require('./model/UpdateLocal'), require('./model/UpdatePackage'), require('./model/UpdateVersion'), require('./model/UploadMedia'), require('./model/User'), require('./model/UserData'), require('./model/Users'), require('./model/Validator'), require('./model/ValidatorPlan'), require('./model/Version'), require('./model/Versions'), require('./model/WordPressSettings'), require('./api/AccountsApi'), require('./api/LibraryApi'), require('./api/LocalApi'), require('./api/PackagesApi'), require('./api/SettingsApi'));
  }
}(function(ApiClient, Account, Accounts, Acquisition, Activationchallenge, AddMember, AddPending, AddRating, BlendedPackage, Body, ChangeCurrentAccount, ClonePackage, ConflictFile, CreateAccount, CreateCanonical, CreateCanonicalVersion, CreatePackage, CreateVersion, Dependencies, DependenciesList, Documents, Error, ErrorResponse400, ErrorResponse500, Files, GetUpdates, HyperLinkAccount, HyperLinkCanonicalVersion, HyperLinkDependencyPackages, HyperLinkDraft, HyperLinkLicenses, HyperLinkRatings, HyperLinkValidators, InlineResponse200, License, Login, Logout, MakeActive, MemberAccount, MemberAccounts, Menu, MergePackage, NavigationItems, NavigationItemsItems, NavigationMeta, NavigationSetting, Navigations, NavigationsMeta, NewDraft, Operands, PackageImages, Packages, PendingAccount, PendingAccounts, PullPackage, PushPackage, Rating, RejectAcquisitionPackage, ResendAccountVerificationLink, ResendInvite, ResetPassword, SaveFile, SessionData, SetUpdates, SharedPackageAccount, SharedPackageAccountsList, ThemeSettings, UpdateAccount, UpdateDraft, UpdateLocal, UpdatePackage, UpdateVersion, UploadMedia, User, UserData, Users, Validator, ValidatorPlan, Version, Versions, WordPressSettings, AccountsApi, LibraryApi, LocalApi, PackagesApi, SettingsApi) {
  'use strict';

  /**
   * A collection of Swagger documentation for the Blended Host APIs..<br>
   * The <code>index</code> module provides access to constructors for all the classes which comprise the public API.
   * <p>
   * An AMD (recommended!) or CommonJS application will generally do something equivalent to the following:
   * <pre>
   * var Swagger = require('./index'); // See note below*.
   * var xxxSvc = new Swagger.XxxApi(); // Allocate the API class we're going to use.
   * var yyyModel = new Swagger.Yyy(); // Construct a model instance.
   * yyyModel.someProperty = 'someValue';
   * ...
   * var zzz = xxxSvc.doSomething(yyyModel); // Invoke the service.
   * ...
   * </pre>
   * <em>*NOTE: For a top-level AMD script, use require(['./index'], function(){...}) and put the application logic within the
   * callback function.</em>
   * </p>
   * <p>
   * A non-AMD browser application (discouraged) might do something like this:
   * <pre>
   * var xxxSvc = new Swagger.XxxApi(); // Allocate the API class we're going to use.
   * var yyy = new Swagger.Yyy(); // Construct a model instance.
   * yyyModel.someProperty = 'someValue';
   * ...
   * var zzz = xxxSvc.doSomething(yyyModel); // Invoke the service.
   * ...
   * </pre>
   * </p>
   * @module index
   * @version 1.0.0
   */
  var exports = {
    /**
     * The ApiClient constructor.
     * @property {module:ApiClient}
     */
    ApiClient: ApiClient,
    /**
     * The Account model constructor.
     * @property {module:model/Account}
     */
    Account: Account,
    /**
     * The Accounts model constructor.
     * @property {module:model/Accounts}
     */
    Accounts: Accounts,
    /**
     * The Acquisition model constructor.
     * @property {module:model/Acquisition}
     */
    Acquisition: Acquisition,
    /**
     * The Activationchallenge model constructor.
     * @property {module:model/Activationchallenge}
     */
    Activationchallenge: Activationchallenge,
    /**
     * The AddMember model constructor.
     * @property {module:model/AddMember}
     */
    AddMember: AddMember,
    /**
     * The AddPending model constructor.
     * @property {module:model/AddPending}
     */
    AddPending: AddPending,
    /**
     * The AddRating model constructor.
     * @property {module:model/AddRating}
     */
    AddRating: AddRating,
    /**
     * The BlendedPackage model constructor.
     * @property {module:model/BlendedPackage}
     */
    BlendedPackage: BlendedPackage,
    /**
     * The Body model constructor.
     * @property {module:model/Body}
     */
    Body: Body,
    /**
     * The ChangeCurrentAccount model constructor.
     * @property {module:model/ChangeCurrentAccount}
     */
    ChangeCurrentAccount: ChangeCurrentAccount,
    /**
     * The ClonePackage model constructor.
     * @property {module:model/ClonePackage}
     */
    ClonePackage: ClonePackage,
    /**
     * The ConflictFile model constructor.
     * @property {module:model/ConflictFile}
     */
    ConflictFile: ConflictFile,
    /**
     * The CreateAccount model constructor.
     * @property {module:model/CreateAccount}
     */
    CreateAccount: CreateAccount,
    /**
     * The CreateCanonical model constructor.
     * @property {module:model/CreateCanonical}
     */
    CreateCanonical: CreateCanonical,
    /**
     * The CreateCanonicalVersion model constructor.
     * @property {module:model/CreateCanonicalVersion}
     */
    CreateCanonicalVersion: CreateCanonicalVersion,
    /**
     * The CreatePackage model constructor.
     * @property {module:model/CreatePackage}
     */
    CreatePackage: CreatePackage,
    /**
     * The CreateVersion model constructor.
     * @property {module:model/CreateVersion}
     */
    CreateVersion: CreateVersion,
    /**
     * The Dependencies model constructor.
     * @property {module:model/Dependencies}
     */
    Dependencies: Dependencies,
    /**
     * The DependenciesList model constructor.
     * @property {module:model/DependenciesList}
     */
    DependenciesList: DependenciesList,
    /**
     * The Documents model constructor.
     * @property {module:model/Documents}
     */
    Documents: Documents,
    /**
     * The Error model constructor.
     * @property {module:model/Error}
     */
    Error: Error,
    /**
     * The ErrorResponse400 model constructor.
     * @property {module:model/ErrorResponse400}
     */
    ErrorResponse400: ErrorResponse400,
    /**
     * The ErrorResponse500 model constructor.
     * @property {module:model/ErrorResponse500}
     */
    ErrorResponse500: ErrorResponse500,
    /**
     * The Files model constructor.
     * @property {module:model/Files}
     */
    Files: Files,
    /**
     * The GetUpdates model constructor.
     * @property {module:model/GetUpdates}
     */
    GetUpdates: GetUpdates,
    /**
     * The HyperLinkAccount model constructor.
     * @property {module:model/HyperLinkAccount}
     */
    HyperLinkAccount: HyperLinkAccount,
    /**
     * The HyperLinkCanonicalVersion model constructor.
     * @property {module:model/HyperLinkCanonicalVersion}
     */
    HyperLinkCanonicalVersion: HyperLinkCanonicalVersion,
    /**
     * The HyperLinkDependencyPackages model constructor.
     * @property {module:model/HyperLinkDependencyPackages}
     */
    HyperLinkDependencyPackages: HyperLinkDependencyPackages,
    /**
     * The HyperLinkDraft model constructor.
     * @property {module:model/HyperLinkDraft}
     */
    HyperLinkDraft: HyperLinkDraft,
    /**
     * The HyperLinkLicenses model constructor.
     * @property {module:model/HyperLinkLicenses}
     */
    HyperLinkLicenses: HyperLinkLicenses,
    /**
     * The HyperLinkRatings model constructor.
     * @property {module:model/HyperLinkRatings}
     */
    HyperLinkRatings: HyperLinkRatings,
    /**
     * The HyperLinkValidators model constructor.
     * @property {module:model/HyperLinkValidators}
     */
    HyperLinkValidators: HyperLinkValidators,
    /**
     * The InlineResponse200 model constructor.
     * @property {module:model/InlineResponse200}
     */
    InlineResponse200: InlineResponse200,
    /**
     * The License model constructor.
     * @property {module:model/License}
     */
    License: License,
    /**
     * The Login model constructor.
     * @property {module:model/Login}
     */
    Login: Login,
    /**
     * The Logout model constructor.
     * @property {module:model/Logout}
     */
    Logout: Logout,
    /**
     * The MakeActive model constructor.
     * @property {module:model/MakeActive}
     */
    MakeActive: MakeActive,
    /**
     * The MemberAccount model constructor.
     * @property {module:model/MemberAccount}
     */
    MemberAccount: MemberAccount,
    /**
     * The MemberAccounts model constructor.
     * @property {module:model/MemberAccounts}
     */
    MemberAccounts: MemberAccounts,
    /**
     * The Menu model constructor.
     * @property {module:model/Menu}
     */
    Menu: Menu,
    /**
     * The MergePackage model constructor.
     * @property {module:model/MergePackage}
     */
    MergePackage: MergePackage,
    /**
     * The NavigationItems model constructor.
     * @property {module:model/NavigationItems}
     */
    NavigationItems: NavigationItems,
    /**
     * The NavigationItemsItems model constructor.
     * @property {module:model/NavigationItemsItems}
     */
    NavigationItemsItems: NavigationItemsItems,
    /**
     * The NavigationMeta model constructor.
     * @property {module:model/NavigationMeta}
     */
    NavigationMeta: NavigationMeta,
    /**
     * The NavigationSetting model constructor.
     * @property {module:model/NavigationSetting}
     */
    NavigationSetting: NavigationSetting,
    /**
     * The Navigations model constructor.
     * @property {module:model/Navigations}
     */
    Navigations: Navigations,
    /**
     * The NavigationsMeta model constructor.
     * @property {module:model/NavigationsMeta}
     */
    NavigationsMeta: NavigationsMeta,
    /**
     * The NewDraft model constructor.
     * @property {module:model/NewDraft}
     */
    NewDraft: NewDraft,
    /**
     * The Operands model constructor.
     * @property {module:model/Operands}
     */
    Operands: Operands,
    /**
     * The PackageImages model constructor.
     * @property {module:model/PackageImages}
     */
    PackageImages: PackageImages,
    /**
     * The Packages model constructor.
     * @property {module:model/Packages}
     */
    Packages: Packages,
    /**
     * The PendingAccount model constructor.
     * @property {module:model/PendingAccount}
     */
    PendingAccount: PendingAccount,
    /**
     * The PendingAccounts model constructor.
     * @property {module:model/PendingAccounts}
     */
    PendingAccounts: PendingAccounts,
    /**
     * The PullPackage model constructor.
     * @property {module:model/PullPackage}
     */
    PullPackage: PullPackage,
    /**
     * The PushPackage model constructor.
     * @property {module:model/PushPackage}
     */
    PushPackage: PushPackage,
    /**
     * The Rating model constructor.
     * @property {module:model/Rating}
     */
    Rating: Rating,
    /**
     * The RejectAcquisitionPackage model constructor.
     * @property {module:model/RejectAcquisitionPackage}
     */
    RejectAcquisitionPackage: RejectAcquisitionPackage,
    /**
     * The ResendAccountVerificationLink model constructor.
     * @property {module:model/ResendAccountVerificationLink}
     */
    ResendAccountVerificationLink: ResendAccountVerificationLink,
    /**
     * The ResendInvite model constructor.
     * @property {module:model/ResendInvite}
     */
    ResendInvite: ResendInvite,
    /**
     * The ResetPassword model constructor.
     * @property {module:model/ResetPassword}
     */
    ResetPassword: ResetPassword,
    /**
     * The SaveFile model constructor.
     * @property {module:model/SaveFile}
     */
    SaveFile: SaveFile,
    /**
     * The SessionData model constructor.
     * @property {module:model/SessionData}
     */
    SessionData: SessionData,
    /**
     * The SetUpdates model constructor.
     * @property {module:model/SetUpdates}
     */
    SetUpdates: SetUpdates,
    /**
     * The SharedPackageAccount model constructor.
     * @property {module:model/SharedPackageAccount}
     */
    SharedPackageAccount: SharedPackageAccount,
    /**
     * The SharedPackageAccountsList model constructor.
     * @property {module:model/SharedPackageAccountsList}
     */
    SharedPackageAccountsList: SharedPackageAccountsList,
    /**
     * The ThemeSettings model constructor.
     * @property {module:model/ThemeSettings}
     */
    ThemeSettings: ThemeSettings,
    /**
     * The UpdateAccount model constructor.
     * @property {module:model/UpdateAccount}
     */
    UpdateAccount: UpdateAccount,
    /**
     * The UpdateDraft model constructor.
     * @property {module:model/UpdateDraft}
     */
    UpdateDraft: UpdateDraft,
    /**
     * The UpdateLocal model constructor.
     * @property {module:model/UpdateLocal}
     */
    UpdateLocal: UpdateLocal,
    /**
     * The UpdatePackage model constructor.
     * @property {module:model/UpdatePackage}
     */
    UpdatePackage: UpdatePackage,
    /**
     * The UpdateVersion model constructor.
     * @property {module:model/UpdateVersion}
     */
    UpdateVersion: UpdateVersion,
    /**
     * The UploadMedia model constructor.
     * @property {module:model/UploadMedia}
     */
    UploadMedia: UploadMedia,
    /**
     * The User model constructor.
     * @property {module:model/User}
     */
    User: User,
    /**
     * The UserData model constructor.
     * @property {module:model/UserData}
     */
    UserData: UserData,
    /**
     * The Users model constructor.
     * @property {module:model/Users}
     */
    Users: Users,
    /**
     * The Validator model constructor.
     * @property {module:model/Validator}
     */
    Validator: Validator,
    /**
     * The ValidatorPlan model constructor.
     * @property {module:model/ValidatorPlan}
     */
    ValidatorPlan: ValidatorPlan,
    /**
     * The Version model constructor.
     * @property {module:model/Version}
     */
    Version: Version,
    /**
     * The Versions model constructor.
     * @property {module:model/Versions}
     */
    Versions: Versions,
    /**
     * The WordPressSettings model constructor.
     * @property {module:model/WordPressSettings}
     */
    WordPressSettings: WordPressSettings,
    /**
     * The AccountsApi service constructor.
     * @property {module:api/AccountsApi}
     */
    AccountsApi: AccountsApi,
    /**
     * The LibraryApi service constructor.
     * @property {module:api/LibraryApi}
     */
    LibraryApi: LibraryApi,
    /**
     * The LocalApi service constructor.
     * @property {module:api/LocalApi}
     */
    LocalApi: LocalApi,
    /**
     * The PackagesApi service constructor.
     * @property {module:api/PackagesApi}
     */
    PackagesApi: PackagesApi,
    /**
     * The SettingsApi service constructor.
     * @property {module:api/SettingsApi}
     */
    SettingsApi: SettingsApi
  };

  return exports;
}));



/*****************
 ** WEBPACK FOOTER
 ** ./~/swagger/src/index.js
 ** module id = 186
 ** module chunks = 0
 **/